export const TITLE_SUCCESS = "Gelukt";
export const TITLE_WARNING = "Waarschuwing";
export const TITLE_ERROR = "Fout";
export const TITLE_INFO = "Info";

export const MESSAGE_VALIDATION_ERRORS = "Er zijn validatiefouten.";
export const MESSAGE_VALIDATION_ERRORS_SAVED = "Alle verplichte vakjes moeten ingevuld zijn vooraleer de machtigingsaanvraag kan doorgestuurd worden naar ANB.";
export const MESSAGE_NOT_SAVED_CONCURRENCY_EXCEPTION = "Dit onderdeel van je dossier werd reeds elders of door iemand anders aangepast! Gelieve je browser te herladen (CTRL-F5) of volledig te sluiten, om op de meest recente aanpassingen van je dossier verder te werken.";
export const MESSAGE_FILE_EXCEPTION = "Verwerken van bestand is mislukt";
export const MESSAGE_SAVED = "Opgeslagen.";
export const MESSAGE_ERROR = "Er is een fout opgetreden.";
export const MESSAGE_VALIDATION_WARNING_LUS_NIET_VOLLEDIG = "Uw lus is nog niet volledig.";
export const MESSAGE_RAPPORT_SIMULATIE_GENEREREN = "Uw simulatierapport wordt gegenereerd";
export const MESSAGE_PDF_GENEREREN = "Uw PDF wordt gegenereerd";
export const MESSAGE_TOCHT_VERWIJDERD = "Jouw tocht is verwijderd";

export const MESSAGE_SPORTTAKKEN_NOSEARCHRESULT = "Geen sporttakken gevonden die voldoen aan de opgegeven zoekcriteria.";
export const MESSAGE_INFRASTRUCTUREN_NOSEARCHRESULT = "Geen infrastructuren gevonden die voldoen aan de opgegeven zoekcriteria.";
export const MESSAGE_INFRASTRUCTUREN_MANYRESULTS = "Meer dan 100 zoekresultaten gevonden, verfijn je zoekcriteria.";

export const MESSAGE_NO_VALID_TRANSACTION_FOUND = "Sport Vlaanderen werkt momenteel aan de gegevens van deze sportclub. Je kan nu geen wijzigingen aanvragen voor deze sportclub , probeer het later nog eens.";